import { JSX } from 'react';
import { DESKTOP_DRAWER_WIDTH } from '../config/constants';
import { Button, Drawer, Stack, Typography, useTheme } from '@mui/material';

export type DesktopDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  collapseBtn?: {
    icon: JSX.Element;
    label: string;
  };
  children: JSX.Element;
};

export function DesktopDrawer({
  isOpen,
  onClose,
  onOpen,
  collapseBtn,
  children,
}: DesktopDrawerProps) {
  const { spacing } = useTheme();
  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      variant="persistent"
      hideBackdrop
      data-treedistestid="drawer-desktop-main"
      slotProps={{
        paper: {
          sx: {
            maxWidth: DESKTOP_DRAWER_WIDTH,
            position: 'relative',
            overflow: 'visible',
            height: '100vh',
          },
        },
      }}
    >
      <Stack sx={{ overflow: 'hidden', height: '100%', maxHeight: '100vh' }}>{children}</Stack>

      {collapseBtn && (
        <Button
          onClick={isOpen ? onClose : onOpen}
          data-treedistestid="button-drawer-toggle"
          sx={{
            color: 'grey.800',
            position: 'absolute',
            background: '#fff',
            borderRadius: '12px 12px 0px 0px',
            padding: spacing(0.9, 2),
            display: 'flex',
            gap: '8px',
            top: '50%',
            right: '-20px',
            transform: 'rotate(-90deg)',
            transformOrigin: 'right',
            visibility: 'visible',

            '&>svg': {
              rotate: '90deg',
              width: '18px',
              height: '18px',
            },
          }}
        >
          <Typography variant="body1" fontWeight="500" whiteSpace="nowrap">
            {collapseBtn.label}
          </Typography>
          {collapseBtn.icon}
        </Button>
      )}
    </Drawer>
  );
}
